/* eslint-disable no-unused-vars */
import UUID from 'uuid'
import CONSTS from '../beans/SERVICE_TYPES'
import { MiscUtil, mergeConfig, deepCopy, merge2Obj } from '../../miscUtil'
import { getOdmsOptions, newOdmsLayer } from '../odms/odmsUtil'
import { getDqsOptions } from '../dqsUtil'

/**
 * 创建服务
 * @param {*} type
 * @param  {...any} rest
 */
export default async (type, ...rest) => {
    switch (type.toUpperCase()) {
        case 'WMS':
            return createWMSService(...rest)
        case 'WMTS':
            return createWMTSService(...rest)
        case 'VWMTS':
            return createVWMTSService(...rest)
        case 'VTS':
            return createVTSService(...rest)
        case 'VVTS':
            return createVVTSService(...rest)
        case 'TILE':
            return createTILEService(...rest)
        case 'TMS':
            return createTMSService(...rest)
        case 'ODMS':
            return createODMSService(...rest)
        // 表格可视化
        case 'DQS':
            return createDQSService(...rest)
        // WFS
        case 'WFS':
            return createWFSService(...rest)
        case 'ERSIVTS':
            return createErsiVTSService(...rest)
        default:
            throw '暂不支持的服务类型'
    }
}
async function createErsiVTSService(config, minZoom, maxZoom) {
    let { type, name, url, visibility, opacity, maxExtent } = mergeConfig(deepCopy(config), CONSTS.VTS)
    type = 'VTS'

    return Promise.all([MiscUtil.fetch(url + '/resources/styles/root.json'),MiscUtil.fetch(url + '?f=pjson')]).then(respone=>{
        let result = respone[0],pjson = respone[1]
        if(!minZoom){
            minZoom = pjson.minzoom
        }
        if(!maxZoom){
            maxZoom = pjson.maxzoom
        }
        let { sprite, glyphs } = result
        if (sprite) {
            sprite = url + '/resources' + sprite.replace('..', '')
        }
        if (glyphs) {
            glyphs = url + '/resources' + glyphs.replace('..', '')
        }
        const random = UUID.v1()
        const sourceId = 'sourceId_' + name + '_' + random
        const vecSource = {
            id: sourceId,
            type: 'vector',
            minzoom: minZoom,
            maxzoom: config.maxSource || pjson.maxLOD - 1,
            tiles: [url + '/tile/{z}/{y}/{x}.pbf'],
            config: deepCopy(config)
        }
        const { layers = [] } = result
        const Layer_data = layers.filter(l => {
            if (l.layout && l.layout.visibility === 'none') {
                return false
            }
            return true
        }).map(l => {
            // 附加其他参数
            l = merge2Obj(l, {
                source: sourceId,
                name: l['source-layer'],
                layout: { visibility: visibility ? 'visible' : 'none' },
                paint: {},
            })
            // id
            l.id += random
            // 透明度
            l.paint[
                l.type === 'symbol' ? 'text-opacity' : l.type + '-opacity'
                ] = opacity
            // 缩放级别
            l.minzoom = l.minzoom ?
                l.minzoom < minZoom ?
                    minZoom :
                    l.minzoom :
                minZoom
            l.maxzoom = l.maxzoom ?
                l.maxzoom > maxZoom ?
                    maxZoom :
                    l.maxzoom :
                maxZoom
            return l
        })

        // 返回的layer
        const vecLayer = {
            layerData: Layer_data,
            sprite: sprite,
            //glyphs: glyphs
        }
        return { type, data: { layer: vecLayer, source: vecSource } }
    })
}

// 创建wms服务
async function createWMSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        url,
        version,
        format,
        epsg,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.WMS)

    const baseUrl = `SERVICE=WMS&REQUEST=GetMap&VERSION=${version}&LAYERS=${name}&BBOX={bbox-epsg-3857}&WIDTH=256&HEIGHT=256&SRS=EPSG:4490&FORMAT=${format}&TRANSPARENT=true&styles=`

    if (url.indexOf('?') > -1) {
        // url = MiscUtil.getProxyUrl(url + '&' + baseUrl)
        url = url + '&' + baseUrl
    } else {
        // url = MiscUtil.getProxyUrl(url + '?' + baseUrl)
        url = url + '?' + baseUrl
    }

    const random = UUID.v1()

    const wmsSource = new GeoGlobe.Source.RasterSource({
        id: 'sourceId_' + name + '_' + random,
        type: 'raster',
        url: [url],
        tileSize: 256
    })
    const wmsLayer = new GeoGlobe.Layer.RasterLayer({
        id: 'layerId_' + name + '_' + random,
        type: 'raster',
        source: wmsSource.id,
        name: name,
        metadata: {
            type,
            maxExtent: maxExtent
        },
        minzoom: minZoom,
        maxzoom: maxZoom > 24 ? 24 : maxZoom,
        paint: {
            'raster-opacity': opacity
        },
        layout: {
            visibility: visibility ? 'visible' : 'none'
        }
    })

    return { type, data: { layer: wmsLayer, source: wmsSource } }
}

// 创建wmts服务
async function createWMTSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        alias,
        url,
        version,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        visibility,
        opacity,
        maxExtent,
        metadata,
        supportCrossDomain
    } = mergeConfig(deepCopy(config), CONSTS.WMTS)
    alias = config.alias

    const baseUrl = `SERVICE=WMTS&REQUEST=GetTile&VERSION=${version}&LAYER=${name}&STYLE=${style}&TILEMATRIXSET=${matrixSet}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=${format}`
    if (url.indexOf('?') > -1) {
        url = url + '&' + baseUrl
    } else {
        url = url + '?' + baseUrl
    }
    //添加代理
    if(!supportCrossDomain){
        if(!url.includes("tianditu.gov.cn")){
            url = MiscUtil.getProxyUrl(url);
        }
    }

    const random = UUID.v1()

    const wmtsSource = new GeoGlobe.Source.RasterSource({
        id: 'sourceId_' +  alias + '_' + random,
        type: 'raster',
        url: [url],
        minzoom: config.minZoom,
        maxzoom: config.maxZoom,
        tileSize: 256
    })

    wmtsSource.zoomOffset = zoomOffset
    wmtsSource.noFadingParent = true //无父级瓦片缓存

    const wmtsLayer = new GeoGlobe.Layer.RasterLayer({
        id: 'layerId_' +  alias + '_' + random,
        type: 'raster',
        source: wmtsSource.id,
        name: name,
        metadata: {
            type,
            maxExtent: maxExtent
        },
        minzoom: config.minZoom,
        maxzoom: config.maxZoom,

        paint: {
            'raster-opacity': opacity
        },
        layout: {
            visibility: visibility ? 'visible' : 'none'
        }
    })

    return { type, data: { layer: wmtsLayer, source: wmtsSource } }
}

// 创建影像多实现
async function createVWMTSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        alias,
        url,
        version,
        style,
        time,
        userecent,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.VWMTS)

    const baseUrl = `SERVICE=WMTS&REQUEST=GetTile&USERECENT=${userecent}&TIME=${time}&VERSION=${version}&LAYER=${name}&STYLE=${style}&TILEMATRIXSET=${matrixSet}&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=${format}`

    if (url.indexOf('?') > -1) {
        // url = MiscUtil.getProxyUrl(url + '&' + baseUrl)
        url = url + '&' + baseUrl
    } else {
        // url = MiscUtil.getProxyUrl(url + '?' + baseUrl)
        url = url + '?' + baseUrl
    }

    const random = UUID.v1()

    const vwmtsSource = new GeoGlobe.Source.RasterSource({
        id: 'sourceId_' +  alias + '_' + random,
        type: 'raster',
        url: [url],
        minzoom: minZoom,
        maxzoom: maxZoom,
        tileSize: 256
    })

    vwmtsSource.zoomOffset = zoomOffset

    const vwmtsLayer = new GeoGlobe.Layer.RasterLayer({
        id: 'layerId_' +  alias + '_' + random,
        type: 'raster',
        source: vwmtsSource.id,
        name: name,
        metadata: {
            type,
            maxExtent: maxExtent,
            // 用于切换时间重新生成layer
            config: deepCopy(config)
        },
        minzoom: minZoom,
        maxzoom: maxZoom,

        paint: {
            'raster-opacity': opacity
        },
        layout: {
            visibility: visibility ? 'visible' : 'none'
        }
    })

    return { type, data: { layer: vwmtsLayer, source: vwmtsSource } }
}

// 创建矢量切片
async function createVTSService(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        version,
        styles,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        formats,
        visibility,
        opacity,
        maxExtent
    } = mergeConfig(deepCopy(config), CONSTS.VTS)
    const serviceVTS = new GeoGlobe.Service.VTS('VTS服务', url, { async: true })

    return MiscUtil.getDSWithPorxyByVTS(url + '?SERVICE=WMTS', {
        params: {
            REQUEST: 'GetStyle',
            VERSION: version,
            STYLENAME: style
        }
    }).then(result => {
        // 标注和字体
        let { sprite, glyphs } = result

        // 请求参数
        const option_param = {
            layer: name,
            TILEMATRIX: '{z}',
            TILEROW: '{y}',
            TILECOL: '{x}',
            tileMatrixSet: matrixSet,
            // width: 256,
            // height: 256,
            format: format
        }

        //组成请求串, 构建source
        const url_vts = serviceVTS.GetTile(option_param)
        const random = UUID.v1()
        const sourceId = 'sourceId_' + name + '_' + random
        const vecSource = {
            id: sourceId,
            type: 'vector',
            // minzoom: minZoom,
            // maxzoom: config.maxZoom,
            minzoom: 13,
            maxzoom: 22,
            tiles: [url_vts],
            config: deepCopy(config)
        }

        // 附加layers参数
        const { layers = [] } = result
        const Layer_data = layers
            .filter(l => {
                if (l.layout && l.layout.visibility === 'none') {
                    return false
                }
                return true
            })
            .map(l => {
                // 附加其他参数
                if(l.type == 'symbol'){
                    // l.layout['icon-allow-overlap'] = false
                    // l.layout['text-allow-overlap'] = false
                    l.layout['icon-padding'] = 30
                    l.layout['text-padding'] = 30
                }
                l = merge2Obj(l, {
                    source: sourceId,
                    name: l['source-layer'],
                    layout: { visibility: visibility ? 'visible' : 'none' },
                    paint: {},
                    metadata: {
                        type,
                        maxExtent,
                        // 配置的可见度
                        visibility: visibility ? 'visible' : 'none',
                        originId: l.id
                    }
                })
                // id
                l.id += random
                // 透明度
                l.paint[
                    l.type === 'symbol' ? 'text-opacity' : l.type + '-opacity'
                    ] = opacity
                // 缩放级别
                // l.minzoom = l.minzoom ?
                //     l.minzoom < minZoom ?
                //         minZoom :
                //         l.minzoom :
                //     minZoom
                // l.maxzoom = l.maxzoom ?
                //     l.maxzoom > maxZoom ?
                //         maxZoom :
                //         l.maxzoom :
                //     maxZoom
                l.minzoom = l.minzoom ?
                    l.minzoom < 13 ?
                        13 :
                        l.minzoom :
                    13
                l.maxzoom = l.maxzoom ?
                    l.maxzoom > 23 ?
                        23 :
                        l.maxzoom :
                    23
                return l
            })

        // 返回的layer
        const vecLayer = {
            layerData: Layer_data,
            sprite: sprite,
            glyphs: glyphs
        }
        return { type, data: { layer: vecLayer, source: vecSource } }
    })
}

async function createVTSService__(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        version,
        styles,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        formats,
        visibility,
        opacity,
        maxExtent,
    } = mergeConfig(deepCopy(config), CONSTS.VTS)

    const serviceVTS = new GeoGlobe.Service.VTS('VTS服务', url, {
        async: true,
    });

    return MiscUtil.getDSWithPorxyByVTS(url + '?SERVICE=WMTS', {
        params: {
            REQUEST: 'GetStyle',
            VERSION: version,
            STYLENAME: style
        }
    }).then(result => {
        // 标注和字体
        let { sprite, glyphs } = result;
        // if (sprite) {
        //     sprite = MiscUtil.getProxyUrl(sprite);
        // }
        // if (glyphs) {
        //     glyphs = MiscUtil.getProxyUrl(glyphs);
        // }

        // 请求参数
        const optionParam = {
            layer: name,
            TILEMATRIX: '{z}',
            TILEROW: '{y}',
            TILECOL: '{x}',
            tileMatrixSet: matrixSet,
            width: 256,
            height: 256,
            format: format,
        };

        //组成请求串, 构建source
        const url_vts = serviceVTS.GetTile(optionParam)
        const random = UUID.v1()
        const sourceId = 'sourceId_' + name + '_' + random
        const vecSource = {
            id: sourceId,
            type: 'vector',
            minzoom: config.minzoom,
            maxzoom: config.maxZoom,
            tiles: [url_vts],
            // tiles: [MiscUtil.getProxyUrl(url_vts)],
            config: deepCopy(config)
        };

        // 附加layers参数
        const { layers = [] } = result;
        const LayerData = layers
            .filter(l => {
                if (l.layout && l.layout.visibility === 'none') {
                    return false;
                }
                return true;
            })
            .map(l => {
                // 解决泰兴影像注记不显示符号的问题
                if (l.type == 'symbol') {
                    l.layout['icon-allow-overlap'] = true;
                }
                // 附加其他参数
                l = merge2Obj(l, {
                    source: sourceId,
                    name: l['source-layer'],
                    layout: { visibility: visibility ? 'visible' : 'none' },
                    paint: {},
                    metadata: {
                        type,
                        maxExtent,
                        // 配置的可见度
                        visibility: visibility ? 'visible' : 'none',
                        originId: l.id,
                    },
                });
                // id
                l.id = 'layerId_' + l.id + '_' + random;
                // 透明度
                l.paint[
                    l.type === 'symbol' ? 'text-opacity' : l.type + '-opacity'
                ] = opacity;
                // 缩放级别
                l.minzoom = l.minzoom ? Math.max(l.minzoom, config.minZoom) : config.minZoom;
                l.maxzoom = l.maxzoom ? Math.min(l.maxzoom, config.maxZoom) : config.maxZoom;
                return l;
            });

        // 返回的layer
        const vecLayer = {
            layerData: LayerData,
            sprite: sprite,
            glyphs: glyphs,
        };
        return { type, data: { layer: vecLayer, source: vecSource } };
    });
}

// 创建多实现矢量切片
async function createVVTSService(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        times,
        time,
        userecent,
        version,
        styles,
        style,
        zoomOffset,
        matrixSet,
        matrixIds,
        format,
        formats,
        visibility,
        opacity,
        maxExtent
    } = mergeConfig(deepCopy(config), CONSTS.VVTS)

    const serviceVTS = new GeoGlobe.Service.VTS('VTS服务', url, { async: true })
    return MiscUtil.getDSWithPorxy(url + '?SERVICE=WMTS', {
        params: {
            REQUEST: 'GetStyle',
            VERSION: version,
            STYLENAME: styles[times.indexOf(time)]
        }
    }).then(result => {
        // 标注和字体
        let { sprite, glyphs } = result
        // if (sprite) {
        //     sprite = MiscUtil.getProxyUrl(sprite)
        // }
        // if (glyphs) {
        //     glyphs = MiscUtil.getProxyUrl(glyphs)
        // }

        // 请求参数
        const option_param = {
            layer: name,
            TILEMATRIX: '{z}',
            TILEROW: '{y}',
            TILECOL: '{x}',
            tileMatrixSet: matrixSet,
            width: 256,
            height: 256,
            format: format
        }

        //组成请求串, 构建source
        const url_vts =
            serviceVTS.GetTile(option_param) +
            `&TIME=${time}&USERECENT=${userecent}`
        const random = UUID.v1()
        const sourceId = 'sourceId_' + name + '_' + random
        const vecSource = {
            id: sourceId,
            type: 'vector',
            minzoom: minZoom,
            maxzoom: maxZoom,
            // tiles: [MiscUtil.getProxyUrl(url_vts)],
            tiles: [url_vts],
            config: deepCopy(config)
        }

        // 附加layers参数
        const { layers = [] } = result
        const Layer_data = layers
            .filter(l => {
                if (l.layout && l.layout.visibility === 'none') {
                    return false
                }
                return true
            })
            .map(l => {
                // 附加其他参数
                l = merge2Obj(l, {
                    source: sourceId,
                    name: l['source-layer'],
                    layout: { visibility: visibility ? 'visible' : 'none' },
                    paint: {},
                    metadata: {
                        type,
                        maxExtent,
                        // 配置的可见度
                        visibility: visibility ? 'visible' : 'none',
                        originId: l.id
                    }
                })
                // id
                l.id += random
                // 透明度
                l.paint[
                    l.type === 'symbol' ? 'text-opacity' : l.type + '-opacity'
                    ] = opacity
                // 缩放级别
                l.minzoom = l.minzoom ?
                    l.minzoom < minZoom ?
                        minZoom :
                        l.minzoom :
                    minZoom
                l.maxzoom = l.maxzoom ?
                    l.maxzoom > maxZoom ?
                        maxZoom :
                        l.maxzoom :
                    maxZoom
                return l
            })

        // 返回的layer
        const vecLayer = {
            layerData: Layer_data,
            sprite: sprite,
            glyphs: glyphs
        }
        return { type, data: { layer: vecLayer, source: vecSource } }
    })
}

// 创建TILE图层
async function createTILEService(config, minZoom, maxZoom) {
    const {
        type,
        name,
        url,
        version,
        format,
        formats,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.TILE)

    const random = UUID.v1()
    const geotile = new GeoGlobe.Layer.GeoTileLayer({
        id: 'layerId_' + name + '_' + random,
        name: name,
        type: 'raster',
        // url: MiscUtil.getProxyUrl(url),
        url: url,
        tileSize: 256,
        maxextent: maxExtent,
        minzoom: minZoom,
        maxzoom: maxZoom,
        opacity,
        visibility: visibility ? 'visible' : 'none'
    })

    return { type, data: geotile }
}

// 创建tms服务
async function createTMSService(config, minZoom, maxZoom, map) {
    let {
        type,
        name,
        url,
        version,
        layerId,
        chartId,
        format,
        visibility,
        opacity,
        maxExtent,
        hasLegend,
        hasBaseMap,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.TMS)

    const box = GeoGlobe.LngLatBounds.fromString(maxExtent)

    const random = UUID.v1()

    const thematic = new GeoGlobe.Layer.ThematicTileLayer(map, {
        // url: MiscUtil.getProxyUrl(url),
        url: url,
        params: {
            legendType: 0,
            hasEdge: true,
            hasLabel: false,
            hasBaseMap: hasBaseMap,
            hasLegend: hasLegend,
            baseMapExampleColumnNums: 2
        },
        minzoom: minZoom,
        maxzoom: maxZoom,
        id: 'layerId_' + name + '_' + random,
        name: name,
        box: box,
        layerID: layerId,
        chartID: chartId,
        format: format,
        width: map.getCanvas().width,
        height: map.getCanvas().height
    })
    // add layer options
    thematic.layer.paint = {
        'raster-opacity': opacity
    }
    thematic.layer.layout = {
        visibility: visibility ? 'visible' : 'none'
    }
    thematic.layer.metadata = {
        type,
        maxExtent: maxExtent
    }

    return { type, data: thematic.layer }
}

// 创建ODMS服务
async function createODMSService(config, minZoom, maxZoom) {
    let {
        type,
        name,
        layerId,
        chartId,
        url,
        visibility,
        opacity,
        maxExtent,
        metadata
    } = mergeConfig(deepCopy(config), CONSTS.ODMS)

    return getOdmsOptions(url, layerId)
        .then(data => {
            if (data && data.style && data.style.echartOption) {
                return {
                    type,
                    data: newOdmsLayer(data.style.echartOption, {
                        name,
                        visibility,
                        opacity,
                        maxExtent,
                        minZoom,
                        maxZoom
                    })
                }
            }
            throw '获取odms服务信息错误'
        })
        .catch(err => {
            console.error('无效的odms服务', config, err)
            throw '无效的odms服务'
        })
}

// 创建DQS服务
async function createDQSService(config, minZoom, maxZoom) {
    let { type, name, url, version, metadata } = mergeConfig(
        deepCopy(config),
        CONSTS.DQS
    )

    try {
        const echartsOption = await getDqsOptions(url)
        return { type, data: echartsOption }
    } catch (err) {
        console.error('无效的DQS服务', config, err)
        throw '无效的DQS服务'
    }
}

// 创建WFS服务
function createWFSService(config, minZoom, maxZoom) {
    return { type: 'WFS', data: null }
}
